<template>
  <div>
    <div v-if="isConfigurationPage" class="configuration_urls">
      <v-list>
        <v-list-item :to="{ name: 'ORGANIZATION_SETTINGS' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.general')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'COLLABORATORS_MANAGEMENT' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.collaborators')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'WORKFLOW_LIST' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.workflows')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'COURSE_LIST' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$tc('utils.course', 3)"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'QUESTION_TEMPLATE' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.question_template')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'DIRECTORY' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.directory')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'IMPORTS' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.imports')"
            />
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: 'DOCX_TEMPLATE' }">
          <v-list-item-title>
            <div
              class="group_list_item primary--text text_sm"
              v-text="$t('utils.docx_templates')"
            />
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: "ConfigurationPage",
  computed: {
    isConfigurationPage() {
      return this.$route.name === "CONFIGURATION";
    },
  },
};
</script>
<style scoped lang="scss">
.configuration_urls {
  background: #fff;
  padding: 24px;
}
</style>
